/*
  Toiles Glatz — nuancier en forme de parasol — v1.1 (22.10.2026)
  Page Shopify /pages/toiles-glatz (section toiles-glatz) ; montable ailleurs (formulaire interne) :
    window.TGZ.mount(el, { data, root, base, page, history, txt, copy, target, reco }) → { destroy }
  Données : assets/toiles-glatz-data.js (window.TGZ_DATA), régénérées à la main depuis Supabase `matieres`.
  Recommandées par Jardin-Confort : opts.reco = ['684','686','527'] (section : réglage « Toiles recommandées » → data-reco).
  Lien client : ?toile=523 (une toile en grand) ou ?toile=523,646,803 (sélection).
  Textes : objet TXT ci-dessous, surchargeable par le bloc JSON #tgz-txt de la section (traduction plus tard).
  Doc : claude/chantier-toiles-glatz.md
*/
(function () {
  'use strict';
  var VERSION = '1.1';

  var TXT = {
    stats_toiles: 'toiles', stats_qualites: 'qualités', stats_uv: 'protection UV', stats_qs: 'en Quickship',
    num: 'N° de toile', num_ph: 'ex. 523 — ou un nom : Champagne',
    msg_ok: 'qualité', msg_n: ' toiles correspondent', msg_1: ' toile correspond', msg_rien: 'Aucune toile n° ou nom',
    qualite: 'Qualité de toile', toutes: 'Toutes', q: 'Qualité', premium: 'premium', toiles: 'toiles', toile: 'toile',
    roue_aria: 'Nuancier en forme de toile de parasol, un pan par toile. Flèches gauche et droite pour changer de toile.',
    leg_n: ' toiles sur le parasol · passez la souris pour agrandir, cliquez pour choisir',
    leg_1: 'Le parasol entier dans la toile ', leg_0: 'Aucune toile pour ces filtres',
    apercu: 'Aperçu — cliquez pour choisir cette toile', hors: 'Hors nuancier 2026',
    prec: 'Toile précédente', suiv: 'Toile suivante',
    pal_ml: 'Palette Morning Light', pal_sg: 'Palette Sunset Glow', qs: 'Quickship · livraison rapide', rayures: 'Rayures', delicate: 'Toile délicate',
    matiere: 'Matière', poids: 'Poids', tenue: 'Tenue des couleurs', pluie: 'Pluie', aspect: 'Aspect', asavoir: 'À savoir',
    sens_titre: 'Sensibilité de la toile', sens_sous: 'tendance selon Glatz',
    sens_plis: 'Tendance aux plis', sens_plis_ex: 'Marques laissées par les plis, surtout visibles à contre-jour sur les teintes claires.',
    sens_traces: 'Tendance aux traces blanches', sens_traces_ex: 'Fines lignes claires aux endroits pliés, plus visibles sur les teintes foncées.',
    sens_niv: ['Faible', 'Moyenne', 'Forte'],
    sens_note: 'Des phénomènes normaux, plus ou moins visibles selon la couleur. Ils n’enlèvent rien à la solidité ni à l’étanchéité de la toile et ne sont pas un motif de réclamation.',
    sens_aucun: 'Glatz ne publie pas cette évaluation pour cette toile.',
    dispo_sur: 'Disponible sur', parasols: 'parasols Glatz', parasol: 'parasol Glatz', qs_court: 'Quickship',
    configurer: 'Configurer mon parasol Glatz',
    lien: 'Lien direct vers cette toile', copier: 'Copier le lien', copie_ok: '✓ Lien copié', partager: 'Partager…',
    lien_aide: 'Ouvre la page directement sur cette toile en grand. Plusieurs toiles : ?toile=523,646,803',
    indicatif: 'Les couleurs à l’écran sont indicatives. Échantillons de toile au showroom de Lutry.',
    ruban: 'Tout le nuancier en dégradé', ruban_sous: 'Blancs · beiges · jaunes · orangés · rouges · roses · violets · bleus · verts · bruns · gris · noirs',
    couleur: 'Couleur', unies: 'Unies', peu: 'Peu de plis et traces blanches', effacer: 'Effacer les filtres', vide: 'Aucune toile ne correspond à ces filtres.',
    selection: 'Sélection de toiles envoyée par Jardin-Confort', voir_tout: 'Voir tout le nuancier',
    q_titre: 'Trois qualités de toile, à choisir selon l’usage',
    q_intro: 'Toutes les toiles Glatz filtrent plus de 98 % des UV. Ce qui change d’une qualité à l’autre : la tenue des couleurs au soleil, la résistance à la pluie et le toucher.',
    couleurs: 'couleurs', voir_les: 'Voir les', etanch: 'Étanchéité',
    e_titre: 'Pour que la toile dure',
    e1: ['Jamais fermé mouillé.', 'Un parasol replié humide doit être rouvert dès que possible pour sécher.'],
    e2: ['Nettoyage doux.', 'Eau tiède, brosse souple, savon neutre, bien rincer puis laisser sécher.'],
    e3: ['Attaché et housse.', 'Fermé, sanglé et dans sa housse, la toile garde ses couleurs plus longtemps.'],
    e4: ['L’hiver à l’abri.', 'Rangé à l’intérieur, la toile évite l’humidité et les taches de moisissure.'],
    housse: 'Trouver la housse de mon parasol Glatz',
    reco_titre: 'Nos best-sellers', reco_sous: 'Les toiles recommandées par Jardin-Confort, choisies par l’équipe du showroom de Lutry.',
    reco_badge: 'Best-seller · recommandée par Jardin-Confort', reco_filtre: 'Best-sellers Jardin-Confort', reco_court: 'Best-seller',
    reco_plis: 'Ne marque ni les plis ni les traces blanches', reco_sur: 'Sur'
  };

  var QUAL = {
    '5': { mat: 'Acrylique teint dans la masse', g: 'env. 300 g/m²', soleil: 'min. 350–700 jours (niveau 7–8)', court: 'la meilleure', pluie: 'colonne d’eau > 350 mm', aspect: 'Mat, toile solide', plus: 'Coupée et cousue en Suisse · réparable', b1: 100, b2: 100, pour: 'Pour un parasol ouvert tout l’été, en plein soleil, ou en terrasse de restaurant.' },
    '4': { mat: 'Polyester teint dans la masse', g: 'env. 250 g/m²', soleil: 'min. 350 jours (niveau 7)', court: 'très bonne', pluie: 'colonne d’eau > 150 mm', aspect: 'Simple et élégant', plus: 'Toile non réparable', b1: 65, b2: 43, pour: 'Le bon compromis pour un jardin privé : couleurs durables, prix plus doux.' },
    '2': { mat: 'Polyester teint en pièce', g: 'env. 220 g/m²', soleil: 'min. 80–160 jours (niveau 5–6)', court: 'correcte', pluie: 'colonne d’eau > 100 mm', aspect: 'Brillant et léger', plus: 'Toile non réparable', b1: 25, b2: 29, pour: 'Pour un usage occasionnel ou un parasol léger à déplacer souvent.' }
  };

  var FAM = [['blanc', 'Blanc', '#F4F3EE'], ['beige-sable', 'Beige / sable', '#D8CBB0'], ['jaune', 'Jaune', '#F1BE48'], ['orange', 'Orange', '#DB864E'], ['rouge', 'Rouge', '#A6192E'], ['rose', 'Rose', '#CA9A8E'], ['violet', 'Violet / bordeaux', '#5E1F3A'], ['bleu', 'Bleu', '#326295'], ['vert', 'Vert', '#5F7756'], ['brun', 'Brun / taupe', '#7A6855'], ['beton-pierre', 'Béton / pierre', '#C9CBC8'], ['gris', 'Gris', '#A3A3A0'], ['anthracite', 'Anthracite', '#4D4D4B'], ['noir', 'Noir', '#1F1B17'], ['multicolore-motif', 'Rayures', 'repeating-linear-gradient(90deg,#9D2235 0 4px,#f5f4ef 4px 8px)']];
  var ORDRE = ['blanc', 'beige-sable', 'jaune', 'orange', 'rouge', 'rose', 'violet', 'bleu', 'vert', 'brun', 'beton-pierre', 'gris', 'anthracite', 'noir'];
  var SENS_COUL = ['#2f5d50', '#c99a2e', '#b4541f'];
  var BLANC = '#f5f4ef'; // bandes blanches des toiles rayées

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function clarte(hex) {
    var c = [1, 3, 5].map(function (i) { var v = parseInt(hex.slice(i, i + 2), 16) / 255; return v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  // Photos cadrées trop large (drapeau z : 684, 686 — originaux 2000×2000) : on demande à Shopify le centre de la photo
  // à taille réelle, pour que le quadrillage du tissage se voie comme sur les autres toiles Urban (527).
  function imgGrande(t) { return t.z ? t.i + '?crop=region&crop_left=650&crop_top=650&crop_width=700&crop_height=700&width=700' : t.i + '?width=900'; }
  function imgPetite(t) { return t.z ? t.i + '?crop=region&crop_left=880&crop_top=880&crop_width=240&crop_height=240&width=240' : t.v + '?width=240'; }
  function bgToile(t, large) {
    // rayures : bandes de couleur et bandes blanches de même largeur
    var w = large ? 88 : 26;
    return t.m ? 'repeating-linear-gradient(90deg,' + t.x + ' 0 ' + w + 'px,' + BLANC + ' ' + w + 'px ' + (2 * w) + 'px)' : t.x;
  }
  var ICO_G = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICO_D = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var ICO_L = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>';
  var SVGNS = 'http://www.w3.org/2000/svg';

  // ---------- géométrie du parasol (octogone vu de dessus, faces plates à 0°, 45°, 90°…) ----------
  var RAD = Math.PI / 180;
  function f1(n) { return n.toFixed(1); }
  function pt(a, deg) {
    var dl = (((deg + 22.5) % 45) + 45) % 45 - 22.5;
    var r = a / Math.cos(dl * RAD);
    return [r * Math.cos(deg * RAD), r * Math.sin(deg * RAD)];
  }
  function pan(a, t0, t1) {
    var an = [t0], v;
    for (v = Math.ceil((t0 - 22.5) / 45) * 45 + 22.5; v < t1; v += 45) if (v > t0) an.push(v);
    an.push(t1);
    return 'M0 0 L' + an.map(function (t) { var p = pt(a, t); return f1(p[0]) + ' ' + f1(p[1]); }).join(' L') + ' Z';
  }
  // anneau octogonal entre les apothèmes a1 et a2, limité aux angles t0 → t1
  function anneau(a1, a2, t0, t1) {
    var an = [t0], v;
    for (v = Math.ceil((t0 - 22.5) / 45) * 45 + 22.5; v < t1; v += 45) if (v > t0) an.push(v);
    an.push(t1);
    var ext = an.map(function (t) { return pt(a2, t); }), int = an.slice().reverse().map(function (t) { return pt(a1, t); });
    return 'M' + ext.concat(int).map(function (p) { return f1(p[0]) + ' ' + f1(p[1]); }).join(' L') + ' Z';
  }
  // rayures d'un pan : bandes concentriques (comme sur la toile), bande de couleur au bord, même largeur que les bandes blanches
  var RAYE = 26;
  function rayures(a, t0, t1) {
    var d = '', b;
    for (b = a; b > 0; b -= 2 * RAYE) d += anneau(Math.max(b - RAYE, 0.01), b, t0, t1) + ' ';
    return d;
  }

  function mount(el, opts) {
    opts = opts || {};
    var D = opts.data || window.TGZ_DATA;
    if (!el || !D) return { destroy: function () {} };
    var T = Object.assign({}, TXT, opts.txt || {});
    var root = opts.root || '/';
    var base = opts.base || '';
    var pageHandle = opts.page || 'toiles-glatz';
    var target = opts.target ? ' target="' + opts.target + '" rel="noopener"' : '';
    var lienBase = (opts.base || location.origin) + root + 'pages/' + pageHandle + '?toile=';
    var MOD = D.models;

    // toiles + ordre du dégradé (famille principale validée, puis clair → foncé)
    var TL = D.toiles.map(function (t) {
      var princ = t.f.filter(function (f) { return f !== 'multicolore-motif'; })[0];
      return Object.assign({ rang: ORDRE.indexOf(princ), L: clarte(t.x) }, t);
    });
    var ORD = TL.slice().sort(function (a, b) { return a.rang - b.rang || b.L - a.L || (a.m ? 1 : 0) - (b.m ? 1 : 0); });
    var PAR = {}; TL.forEach(function (t) { PAR[t.c] = t; });
    var RECO = (opts.reco || []).map(String).filter(function (c, i, a) { return PAR[c] && a.indexOf(c) === i; });
    var estReco = function (t) { return RECO.indexOf(t.c) >= 0; };

    var st = { reco: false, q: 'all', fam: '', motif: 'all', qs: false, pal: '', peu: false, s: '', sel: null, hov: null, liste: null };
    // paramètres d'adresse (lien envoyé au client)
    if (opts.history !== false) {
      try {
        var prm = new URLSearchParams(location.search).get('toile');
        if (prm) {
          var codes = prm.split(/[\s,;]+/).filter(function (c) { return PAR[c]; });
          if (codes.length === 1) st.sel = codes[0];
          else if (codes.length > 1) { st.liste = codes; st.sel = codes[0]; }
        }
      } catch (e) { /* ignore */ }
    }
    if (opts.query) { var q0 = String(opts.query).split(/[\s,;]+/).filter(function (c) { return PAR[c]; }); if (q0.length) st.sel = q0[0]; }
    if (!st.sel) st.sel = PAR['523'] ? '523' : ORD[0].c;

    function passe(t, sansFam) {
      if (st.liste && st.liste.indexOf(t.c) < 0) return false;
      if (st.reco && !estReco(t)) return false;
      if (st.q !== 'all' && t.q !== st.q) return false;
      if (!sansFam && st.fam && t.f.indexOf(st.fam) < 0) return false;
      if (st.motif === 'uni' && t.m) return false;
      if (st.motif === 'ray' && !t.m) return false;
      if (st.qs && !t.qs) return false;
      if (st.pal && t.p !== st.pal) return false;
      if (st.peu && !(t.s && t.s[0] === 0 && t.s[1] === 0)) return false;
      var s = st.s.trim().toLowerCase();
      if (s) {
        if (/^\d+$/.test(s)) { if (t.c.indexOf(s) !== 0) return false; }
        else if (t.n.toLowerCase().indexOf(s) < 0) return false;
      }
      return true;
    }

    // ---------- cadre ----------
    var nbQ = function (q) { return TL.filter(function (t) { return t.q === q; }).length; };
    var nbQs = TL.filter(function (t) { return t.qs; }).length;
    el.classList.add('tgz');
    el.innerHTML =
      '<div class="tgz-stats">' +
        '<div><b>' + TL.length + '</b><span>' + T.stats_toiles + '</span></div>' +
        '<div><b>3</b><span>' + T.stats_qualites + '</span></div>' +
        '<div><b>&gt; 98 %</b><span>' + T.stats_uv + '</span></div>' +
        '<div><b>' + nbQs + '</b><span>' + T.stats_qs + '</span></div>' +
      '</div>' +
      (RECO.length ? '<div class="tgz-reco"><div class="tgz-reco-h"><strong>' + esc(T.reco_titre) + '</strong><span>' + esc(T.reco_sous) + '</span></div>' +
        '<div class="tgz-reco-l js-reco">' + RECO.map(function (c) {
          var t = PAR[c], md = t.md || [];
          var pts = [];
          if (t.s && t.s[0] === 0 && t.s[1] === 0) pts.push(T.reco_plis);
          if (t.qs) pts.push(T.qs);
          pts.push(T.reco_sur + ' ' + md.length + ' ' + (md.length > 1 ? T.parasols : T.parasol));
          return '<button type="button" class="tgz-reco-c" data-c="' + t.c + '" aria-label="' + esc(T.reco_badge + ' : ' + t.c + ' ' + t.n) + '">' +
            '<span class="tgz-reco-i" style="background:' + bgToile(t) + '"><img src="' + esc(imgPetite(t)) + '" alt="" loading="lazy" decoding="async" onerror="this.style.visibility=\'hidden\'"></span>' +
            '<span class="tgz-reco-t"><b>N° ' + t.c + '</b><strong>' + esc(t.n) + '</strong><em>' + T.q + ' ' + t.q + '</em>' +
            '<ul>' + pts.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul></span></button>';
        }).join('') + '</div></div>' : '') +
      '<div class="tgz-bar">' +
        '<label class="tgz-search"><span class="tgz-lab">' + T.num + '</span>' +
          '<span class="tgz-search-box">' + ICO_L + '<input type="search" inputmode="search" autocomplete="off" class="js-s" placeholder="' + esc(T.num_ph) + '"></span>' +
          '<span class="tgz-msg js-msg" aria-live="polite"></span></label>' +
        '<div class="tgz-qual"><span class="tgz-lab">' + T.qualite + '</span><div class="tgz-seg js-qual" role="group" aria-label="' + esc(T.qualite) + '"></div></div>' +
      '</div>' +
      '<div class="tgz-selban js-selban" hidden></div>' +
      '<div class="tgz-main">' +
        '<div class="tgz-roue">' +
          '<svg class="js-roue" viewBox="-362 -362 724 724" tabindex="0" role="group" aria-label="' + esc(T.roue_aria) + '"><g class="js-pans"></g><circle cx="0" cy="0" r="14" fill="#e9e6e0"></circle><circle cx="0" cy="0" r="5" fill="#b9b4ab"></circle></svg>' +
          '<div class="tgz-roue-lab" aria-live="polite"><b class="js-rcode"></b><span class="js-rnom"></span></div>' +
          '<p class="tgz-legende js-leg"></p>' +
        '</div>' +
        '<div class="tgz-fiche">' +
          '<div class="tgz-big js-big"><img class="js-bigimg" alt="" decoding="async"><span class="tgz-apercu js-apercu" hidden>' + T.apercu + '</span><span class="tgz-hors js-hors" hidden>' + T.hors + '</span><span class="tgz-recob js-recob" hidden>★ ' + T.reco_badge + '</span><span class="tgz-badge js-badge"></span></div>' +
          '<div class="tgz-fb">' +
            '<div class="tgz-nav"><button type="button" class="tgz-rond js-prev" aria-label="' + esc(T.prec) + '">' + ICO_G + '</button>' +
              '<div class="tgz-nom"><b class="tgz-num js-num"></b><strong class="js-nom"></strong><span class="js-code"></span></div>' +
              '<button type="button" class="tgz-rond js-next" aria-label="' + esc(T.suiv) + '">' + ICO_D + '</button></div>' +
            '<div class="tgz-chips js-chips"></div>' +
            '<div class="tgz-specs js-specs"></div>' +
            '<div class="tgz-sens js-sens"></div>' +
            '<div class="tgz-mods js-mods"></div>' +
            '<a class="tgz-btn tgz-btn--pri" href="' + esc(base + root + 'pages/configurer-mon-parasol') + '"' + target + '>' + T.configurer + '</a>' +
            '<div class="tgz-lien"><span class="tgz-lab">' + T.lien + '</span><code class="js-url"></code>' +
              '<div class="tgz-lien-b"><button type="button" class="tgz-btn tgz-btn--sm js-copy">' + T.copier + '</button>' +
              (navigator.share && opts.history !== false ? '<button type="button" class="tgz-btn tgz-btn--sm tgz-btn--lt js-share">' + T.partager + '</button>' : '') + '</div>' +
              '<span class="tgz-aide">' + T.lien_aide + '</span></div>' +
            '<p class="tgz-aide">' + T.indicatif + '</p>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="tgz-ruban-w"><div class="tgz-ruban-h"><strong>' + T.ruban + '</strong><span>' + T.ruban_sous + '</span></div><div class="tgz-ruban js-ruban"></div></div>' +
      '<div class="tgz-filtres">' +
        '<div><span class="tgz-lab">' + T.couleur + '</span><div class="tgz-fams js-fams"></div></div>' +
        '<div class="tgz-opts js-opts"></div>' +
        '<div class="tgz-count"><strong class="js-nb"></strong><button type="button" class="tgz-lnk js-reset" hidden>' + T.effacer + '</button></div>' +
        '<div class="tgz-vide js-vide" hidden>' + T.vide + '</div>' +
        '<div class="tgz-grille js-grille"></div>' +
      '</div>' +
      '<div class="tgz-sec"><h2>' + T.q_titre + '</h2><p>' + T.q_intro + '</p><div class="tgz-cartes">' +
        ['5', '4', '2'].map(function (q) {
          var Q = QUAL[q];
          return '<div class="tgz-carte"><div class="tgz-carte-h"><strong>' + T.q + ' ' + q + '</strong><span>' + nbQ(q) + ' ' + T.couleurs + '</span></div>' +
            '<span class="tgz-carte-m">' + Q.mat + ' · ' + Q.g + '</span>' +
            '<div class="tgz-jauge"><span>' + T.tenue + ' — ' + Q.court + '</span><i><b style="width:' + Q.b1 + '%"></b></i></div>' +
            '<div class="tgz-jauge"><span>' + T.etanch + ' — ' + Q.pluie + '</span><i><b style="width:' + Q.b2 + '%"></b></i></div>' +
            '<p>' + Q.pour + '</p><button type="button" class="tgz-btn tgz-btn--sm tgz-btn--lt js-carteq" data-q="' + q + '">' + T.voir_les + ' ' + nbQ(q) + ' ' + T.toiles + '</button></div>';
        }).join('') + '</div></div>' +
      '<div class="tgz-sec"><h2>' + T.e_titre + '</h2><div class="tgz-entr">' +
        [T.e1, T.e2, T.e3, T.e4].map(function (e) { return '<div><strong>' + e[0] + '</strong> ' + e[1] + '</div>'; }).join('') + '</div>' +
        '<div class="tgz-lien-b"><a class="tgz-btn tgz-btn--lt" href="' + esc(base + root + 'pages/trouver-ma-housse?f=parasol&mat=glatz&go=1') + '"' + target + '>' + T.housse + '</a>' +
        '<a class="tgz-btn tgz-btn--lt" href="' + esc(base + root + 'pages/configurer-mon-parasol') + '"' + target + '>' + T.configurer + '</a></div></div>';

    var $ = function (s) { return el.querySelector(s); };
    var recoL = $('.js-reco'), inp = $('.js-s'), gPans = $('.js-pans'), svg = $('.js-roue'), ruban = $('.js-ruban'), grille = $('.js-grille'), bigImg = $('.js-bigimg');
    var filtres = [], panEls = [], rubEls = [], grilleEls = {};
    var fb = $('.tgz-fb');
    // La fiche change de hauteur d'une toile à l'autre (liste des parasols, sensibilité…). Sur un écran à souris, le survol du
    // bandeau ou de la grille (sous la fiche) les ferait bouger sous la souris → survol en boucle. On donne donc au corps de la
    // fiche la hauteur de la plus haute des toiles (mesurée au chargement et au redimensionnement).
    el.style.overflowAnchor = 'none';
    function caler() {
      fb.style.minHeight = '';
      if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
      var mx = 0;
      TL.forEach(function (t) { ficheCode = null; renderFiche(t, true); mx = Math.max(mx, fb.getBoundingClientRect().height); });
      ficheCode = null; renderFiche(PAR[st.hov] || PAR[st.sel]);
      fb.style.minHeight = Math.ceil(mx) + 2 + 'px';
    }
    var tCaler = null;
    function onResize() { clearTimeout(tCaler); tCaler = setTimeout(caler, 200); }

    // ---------- rendu des filtres, du parasol, du bandeau et de la grille ----------
    function renderFiltres() {
      filtres = ORD.filter(function (t) { return passe(t, false); });
      // la toile choisie n'est plus dans les filtres → on montre la première toile filtrée
      if (filtres.length && !filtres.some(function (t) { return t.c === st.sel; })) { st.sel = filtres[0].c; st.hov = null; }
      // qualité
      $('.js-qual').innerHTML = [['all', T.toutes, TL.length + ' ' + T.toiles], ['5', T.q + ' 5', T.premium + ' · ' + nbQ('5')], ['4', T.q + ' 4', nbQ('4') + ' ' + T.toiles], ['2', T.q + ' 2', nbQ('2') + ' ' + T.toiles]].map(function (x) {
        return '<button type="button" data-q="' + x[0] + '" aria-pressed="' + (st.q === x[0]) + '"><b>' + x[1] + '</b><span>' + x[2] + '</span></button>';
      }).join('');
      // familles
      $('.js-fams').innerHTML = FAM.map(function (f) {
        var n = ORD.filter(function (t) { return passe(t, true) && t.f.indexOf(f[0]) >= 0; }).length;
        if (!n && st.fam !== f[0]) return '';
        return '<button type="button" class="tgz-fam" data-fam="' + f[0] + '" aria-pressed="' + (st.fam === f[0]) + '"><i style="background:' + f[2] + '"></i>' + f[1] + ' <span>' + n + '</span></button>';
      }).join('');
      // options
      $('.js-opts').innerHTML = (RECO.length ? [['reco', '1', '★ ' + T.reco_filtre, st.reco]] : []).concat([['motif', 'uni', T.unies, st.motif === 'uni'], ['motif', 'ray', T.rayures, st.motif === 'ray'], ['qs', '1', T.qs_court, st.qs], ['pal', 'ml', T.pal_ml, st.pal === 'ml'], ['pal', 'sg', T.pal_sg, st.pal === 'sg'], ['peu', '1', T.peu, st.peu]]).map(function (o) {
        return '<button type="button" class="tgz-opt" data-k="' + o[0] + '" data-v="' + o[1] + '" aria-pressed="' + o[3] + '">' + o[2] + '</button>';
      }).join('');
      var actif = st.reco || st.q !== 'all' || st.fam || st.motif !== 'all' || st.qs || st.pal || st.peu || st.s.trim();
      $('.js-reset').hidden = !actif;
      $('.js-nb').textContent = filtres.length + ' ' + (filtres.length > 1 ? T.toiles : T.toile);
      $('.js-vide').hidden = filtres.length > 0;
      // bannière sélection envoyée
      var ban = $('.js-selban');
      if (st.liste) { ban.hidden = false; ban.innerHTML = '<span>' + T.selection + ' (' + st.liste.length + ')</span><button type="button" class="tgz-lnk js-tout">' + T.voir_tout + '</button>'; }
      else ban.hidden = true;
      // grille
      grilleEls = {};
      grille.innerHTML = filtres.map(function (t) {
        return '<button type="button" class="tgz-carre" data-c="' + t.c + '" aria-label="' + esc(T.q + ' ' + t.q + ', ' + t.c + ' ' + t.n) + '">' +
          '<span class="tgz-carre-i" style="background:' + bgToile(t) + '"><img src="' + esc(imgPetite(t)) + '" alt="" loading="lazy" decoding="async" onerror="this.style.visibility=\'hidden\'">' +
          (t.qs ? '<em>' + T.qs_court + '</em>' : '') + (estReco(t) ? '<i class="tgz-star" title="' + esc(T.reco_badge) + '">★</i>' : '') + '</span>' +
          '<span class="tgz-carre-c">' + t.c + ' · Q' + t.q + '</span><span class="tgz-carre-n">' + esc(t.n) + '</span></button>';
      }).join('');
      Array.prototype.forEach.call(grille.children, function (b) { grilleEls[b.getAttribute('data-c')] = b; });
      // parasol : un pan par toile filtrée ; toiles rayées = fond blanc + bandes de couleur concentriques (rayures sur la circonférence)
      gPans.textContent = '';
      panEls = filtres.map(function (t) {
        var g = document.createElementNS(SVGNS, 'g');
        g.setAttribute('data-c', t.c);
        var p = document.createElementNS(SVGNS, 'path');
        p.setAttribute('fill', t.m ? BLANC : t.x);
        p.setAttribute('data-c', t.c);
        g.appendChild(p);
        if (t.m) {
          var r = document.createElementNS(SVGNS, 'path');
          r.setAttribute('fill', t.x);
          r.setAttribute('data-c', t.c);
          r.setAttribute('class', 'js-raye');
          g.appendChild(r);
        }
        var ti = document.createElementNS(SVGNS, 'title'); ti.textContent = t.c + ' ' + t.n + ' (' + T.q.toLowerCase() + ' ' + t.q + ')';
        g.appendChild(ti);
        gPans.appendChild(g);
        return g;
      });
      // bandeau : tout le nuancier
      if (!rubEls.length) {
        ruban.innerHTML = ORD.map(function (t) {
          return '<button type="button" tabindex="-1" data-c="' + t.c + '" title="' + esc(t.c + ' ' + t.n + ' (Q' + t.q + ')') + '" aria-label="' + esc(t.c + ' ' + t.n) + '" style="background:' + bgToile(t) + '"></button>';
        }).join('');
        rubEls = Array.prototype.slice.call(ruban.children);
      }
      rubEls.forEach(function (b, i) { b.classList.toggle('is-off', !passe(ORD[i], false)); });
      var leg = $('.js-leg');
      leg.textContent = filtres.length === 0 ? T.leg_0 : (filtres.length === 1 ? T.leg_1 + filtres[0].c + ' ' + filtres[0].n : filtres.length + T.leg_n);
      renderFocus();
    }

    // ---------- loupe (survol) + fiche ----------
    function renderFocus() {
      var vue = PAR[st.hov] || PAR[st.sel];
      var n = filtres.length;
      var fIdx = -1;
      for (var k = 0; k < n; k++) if (filtres[k].c === vue.c) { fIdx = k; break; }
      var loupe = n > 8 && fIdx >= 0;
      var poids = filtres.map(function (t, i) {
        if (!loupe) return 1;
        var dd = Math.min(Math.abs(i - fIdx), n - Math.abs(i - fIdx));
        return 1 + 5 * Math.exp(-(dd * dd) / 2.4);
      });
      var W = poids.reduce(function (a, b) { return a + b; }, 0) || 1;
      var larg = poids.map(function (w) { return 360 * w / W; });
      var cumul = [], acc = 0;
      larg.forEach(function (l) { cumul.push(acc); acc += l; });
      // le pan survolé garde sa place : il grandit sous la souris sans glisser
      var decal = fIdx >= 0 ? (-90 + (fIdx + 0.5) * 360 / n) - (cumul[fIdx] + larg[fIdx] / 2) : -90;
      panEls.forEach(function (p, i) {
        var dd = fIdx >= 0 ? Math.min(Math.abs(i - fIdx), n - Math.abs(i - fIdx)) : 9;
        var r = dd === 0 ? 330 : (dd === 1 ? 300 : 286);
        var t0 = decal + cumul[i], t1 = t0 + larg[i] + 0.35;
        if (n === 1) { r = 330; t0 = -90; t1 = 270; }
        p.firstChild.setAttribute('d', pan(r, t0, t1));
        var ry = p.querySelector('.js-raye');
        if (ry) ry.setAttribute('d', rayures(r, t0, t1));
      });
      if (fIdx >= 0 && panEls[fIdx]) gPans.appendChild(panEls[fIdx]); // dessiné par-dessus
      // bandeau
      var rIdx = -1;
      for (k = 0; k < ORD.length; k++) if (ORD[k].c === vue.c) { rIdx = k; break; }
      rubEls.forEach(function (b, i) {
        var dd = Math.abs(i - rIdx);
        b.style.flexGrow = dd === 0 ? 7 : (dd === 1 ? 3 : (dd === 2 ? 1.6 : 1));
        b.style.height = dd === 0 ? '6em' : (dd === 1 ? '4.9em' : '3.75em');
      });
      // grille
      if (recoL) Array.prototype.forEach.call(recoL.children, function (b) { var on = b.getAttribute('data-c') === st.sel; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
      Object.keys(grilleEls).forEach(function (c) { var on = c === st.sel; grilleEls[c].classList.toggle('is-on', on); grilleEls[c].setAttribute('aria-pressed', on); });
      renderFiche(vue);
    }

    var ficheCode = null;
    function renderFiche(t, mesure) {
      $('.js-apercu').hidden = t.c === st.sel;
      if (ficheCode === t.c) return;
      ficheCode = t.c;
      var Q = QUAL[t.q];
      if (!mesure) {
        var big = $('.js-big');
        big.style.background = bgToile(t, true);
        bigImg.style.opacity = '0';
        bigImg.onload = function () { if (ficheCode === t.c) bigImg.style.opacity = '1'; };
        bigImg.onerror = function () { bigImg.style.opacity = '0'; };
        bigImg.src = imgGrande(t);
        bigImg.alt = t.c + ' ' + t.n;
        $('.js-hors').hidden = !t.h;
        $('.js-recob').hidden = !estReco(t);
        $('.js-badge').textContent = t.c;
        $('.js-rcode').textContent = t.c;
        $('.js-rnom').textContent = t.n + ' · Q' + t.q;
      }
      $('.js-num').textContent = 'N° ' + t.c;
      $('.js-nom').textContent = t.n;
      $('.js-code').textContent = T.q + ' ' + t.q;
      var delicate = t.s && (t.s[0] === 2 || t.s[1] === 2);
      $('.js-chips').innerHTML =
        (t.p ? '<span>' + (t.p === 'ml' ? T.pal_ml : T.pal_sg) + '</span>' : '') +
        (t.qs ? '<span class="is-qs">' + T.qs + '</span>' : '') +
        (t.m ? '<span>' + T.rayures + '</span>' : '') +
        '<span>' + t.f.map(function (f) { var x = FAM.filter(function (y) { return y[0] === f; })[0]; return x ? x[1].toLowerCase() : f; }).join(', ') + '</span>' +
        (delicate ? '<span class="is-del">' + T.delicate + '</span>' : '');
      $('.js-specs').innerHTML = [[T.matiere, Q.mat], [T.poids, Q.g], [T.tenue, Q.soleil], [T.pluie, Q.pluie], [T.aspect, Q.aspect], [T.asavoir, Q.plus]].map(function (x) {
        return '<div><span>' + x[0] + '</span>' + x[1] + '</div>';
      }).join('');
      $('.js-sens').innerHTML = '<span class="tgz-lab">' + T.sens_titre + ' <em>· ' + T.sens_sous + '</em></span>' +
        (t.s ? [[T.sens_plis, T.sens_plis_ex, t.s[0]], [T.sens_traces, T.sens_traces_ex, t.s[1]]].map(function (x) {
          var lv = x[2];
          return '<div class="tgz-sens-l"><div><span>' + x[0] + '</span><span class="tgz-sens-v"><i aria-hidden="true">' +
            [0, 1, 2].map(function (i) { return '<b style="background:' + (i <= lv ? SENS_COUL[lv] : '#e3dfd8') + '"></b>'; }).join('') +
            '</i>' + T.sens_niv[lv] + '</span></div><small>' + x[1] + '</small></div>';
        }).join('') + '<small>' + T.sens_note + '</small>' : '<small>' + T.sens_aucun + '</small>');
      var md = t.md || [];
      $('.js-mods').innerHTML = '<span class="tgz-lab">' + T.dispo_sur + ' ' + md.length + ' ' + (md.length > 1 ? T.parasols : T.parasol) + '</span><div>' +
        md.map(function (x) {
          var m = MOD[x[0]];
          return '<a href="' + esc(base + root + 'products/' + encodeURIComponent(m.h)) + '"' + target + '>' + esc(m.t) + (x[1] ? ' <em>' + T.qs_court + '</em>' : '') + '</a>';
        }).join('') + '</div>';
      $('.js-url').textContent = lienBase + t.c;
      $('.js-copy').textContent = T.copier;
    }

    // ---------- actions ----------
    function choisir(c) {
      if (!PAR[c]) return;
      st.sel = c; st.hov = null;
      renderFocus();
      if (opts.history !== false && !st.liste) {
        try { var u = new URL(location.href); u.searchParams.set('toile', c); history.replaceState(history.state, '', u.toString()); } catch (e) { /* ignore */ }
      }
    }
    function survol(c) { if (st.hov !== c) { st.hov = c; renderFocus(); } }
    function quitter() { if (st.hov) { st.hov = null; renderFocus(); } }
    function pas(dir) {
      var b = filtres.length ? filtres : ORD, i = -1;
      for (var k = 0; k < b.length; k++) if (b[k].c === st.sel) { i = k; break; }
      choisir(b[i < 0 ? 0 : (i + dir + b.length) % b.length].c);
    }
    function majMsg() {
      var s = st.s.trim(), m = $('.js-msg');
      m.className = 'tgz-msg js-msg';
      if (!s) { m.textContent = ''; return; }
      var ex = PAR[s];
      if (ex) { m.textContent = '✓ ' + ex.c + ' ' + ex.n + ' — ' + T.msg_ok + ' ' + ex.q; m.classList.add('is-ok'); }
      else if (filtres.length) m.textContent = filtres.length + (filtres.length > 1 ? T.msg_n : T.msg_1);
      else { m.textContent = T.msg_rien + ' « ' + s + ' »'; m.classList.add('is-bad'); }
    }
    function copier(txt, btn) {
      var ok = function () { btn.textContent = T.copie_ok; setTimeout(function () { btn.textContent = T.copier; }, 1800); };
      if (typeof opts.copy === 'function') { opts.copy(txt); ok(); return; }
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, function () { repli(); });
      else repli();
      function repli() {
        var ta = document.createElement('textarea'); ta.value = txt; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); ok(); } catch (e) { /* ignore */ }
        document.body.removeChild(ta);
      }
    }

    function onClick(e) {
      var b = e.target.closest('button, path');
      if (!b || !el.contains(b)) return;
      var c = b.getAttribute('data-c');
      if (c && b.closest('.js-reco')) {
        // carte recommandée : si un filtre la cache, on efface les filtres ; puis on montre le parasol
        if (!passe(PAR[c], false)) { st.reco = false; st.q = 'all'; st.fam = ''; st.motif = 'all'; st.qs = false; st.pal = ''; st.peu = false; st.s = ''; inp.value = ''; majMsg(); st.liste = null; st.sel = c; renderFiltres(); }
        choisir(c); svg.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
      }
      if (c && (b.tagName.toLowerCase() === 'path' || b.closest('.js-grille, .js-ruban'))) { choisir(c); return; }
      if (b.hasAttribute('data-q')) { st.q = b.getAttribute('data-q'); if (b.classList.contains('js-carteq')) { st.reco = false; st.fam = ''; st.pal = ''; st.motif = 'all'; st.qs = false; st.peu = false; st.s = ''; inp.value = ''; majMsg(); svg.scrollIntoView({ behavior: 'smooth', block: 'center' }); } renderFiltres(); return; }
      if (b.hasAttribute('data-fam')) { var f = b.getAttribute('data-fam'); st.fam = st.fam === f ? '' : f; renderFiltres(); return; }
      if (b.classList.contains('tgz-opt')) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
        if (k === 'motif') st.motif = st.motif === v ? 'all' : v;
        else if (k === 'pal') st.pal = st.pal === v ? '' : v;
        else st[k] = !st[k];
        renderFiltres(); return;
      }
      if (b.classList.contains('js-prev')) { pas(-1); return; }
      if (b.classList.contains('js-next')) { pas(1); return; }
      if (b.classList.contains('js-reset')) { st.reco = false; st.q = 'all'; st.fam = ''; st.motif = 'all'; st.qs = false; st.pal = ''; st.peu = false; st.s = ''; inp.value = ''; majMsg(); renderFiltres(); return; }
      if (b.classList.contains('js-tout')) {
        st.liste = null; renderFiltres();
        if (opts.history !== false) { try { var u = new URL(location.href); u.searchParams.set('toile', st.sel); history.replaceState(history.state, '', u.toString()); } catch (e2) { /* ignore */ } }
        return;
      }
      if (b.classList.contains('js-copy')) { copier(lienBase + st.sel, b); return; }
      if (b.classList.contains('js-share')) { try { navigator.share({ title: PAR[st.sel].c + ' ' + PAR[st.sel].n, url: lienBase + st.sel }); } catch (e3) { /* ignore */ } }
    }
    function onOver(e) {
      if (e.pointerType === 'touch') return;
      var b = e.target.closest('[data-c]');
      if (b && el.contains(b)) survol(b.getAttribute('data-c'));
    }
    function onLeave(e) { if (e.pointerType === 'touch') return; quitter(); }
    function onInput() {
      st.s = inp.value;
      var ex = PAR[inp.value.trim()];
      if (ex) { st.sel = ex.c; st.hov = null; }
      renderFiltres(); majMsg();
      if (ex) choisir(ex.c);
    }
    function onKeyS(e) { if (e.key === 'Enter') { e.preventDefault(); if (filtres.length) choisir(filtres[0].c); } }
    function onKeyRoue(e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); pas(1); }
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); pas(-1); }
    }

    el.addEventListener('click', onClick);
    svg.addEventListener('pointerover', onOver);
    svg.addEventListener('pointerleave', onLeave);
    svg.addEventListener('keydown', onKeyRoue);
    ruban.addEventListener('pointerover', onOver);
    ruban.addEventListener('pointerleave', onLeave);
    if (recoL) { recoL.addEventListener('pointerover', onOver); recoL.addEventListener('pointerleave', onLeave); }
    grille.addEventListener('pointerover', onOver);
    grille.addEventListener('pointerleave', onLeave);
    inp.addEventListener('input', onInput);
    inp.addEventListener('keydown', onKeyS);

    renderFiltres();
    caler();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (el.isConnected) caler(); });
    window.addEventListener('resize', onResize);

    return {
      destroy: function () {
        window.removeEventListener('resize', onResize);
        el.removeEventListener('click', onClick);
        el.innerHTML = '';
        el.classList.remove('tgz');
      },
      select: choisir
    };
  }

  window.TGZ = { mount: mount, version: VERSION };

  // Montage automatique sur la page Shopify
  function auto() {
    var r = document.getElementById('tgz');
    if (!r || r.getAttribute('data-mounted')) return;
    var app = r.querySelector('.tgz-app');
    if (!app) return;
    r.setAttribute('data-mounted', '1');
    var txt = {};
    try { var tj = document.getElementById('tgz-txt'); if (tj) txt = JSON.parse(tj.textContent || '{}'); } catch (e) { /* ignore */ }
    var reco = (r.getAttribute('data-reco') || '').split(/[\s,;]+/).filter(Boolean);
    mount(app, { data: window.TGZ_DATA, root: r.getAttribute('data-root') || '/', page: r.getAttribute('data-page') || 'toiles-glatz', txt: txt, reco: reco });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
})();
